import { Address } from 'viem'

/**
 * Wallet addresses that should trigger a security alert modal.
 * Users with these addresses will be prompted to review their token approvals.
 *
 * Set via NEXT_PUBLIC_ALERT_ADDRESSES env var as a comma-separated list of addresses.
 * Example: NEXT_PUBLIC_ALERT_ADDRESSES=0x123...,0xabc...,0xdef...
 */
function parseAlertAddresses(): Address[] {
  const envValue = process.env.NEXT_PUBLIC_ALERT_ADDRESSES
  if (!envValue) return []

  return envValue
    .split(',')
    .map((addr) => addr.trim())
    .filter((addr) => addr.length > 0) as Address[]
}

export const ALERT_ADDRESSES: Address[] = parseAlertAddresses()

export function isAddressInAlertList(address: Address | undefined): boolean {
  if (!address) return false
  return ALERT_ADDRESSES.some((alertAddress) => alertAddress.toLowerCase() === address.toLowerCase())
}

const STORAGE_KEY = 'wallet-alert-dismissed-1'

function getAlertDismissedAddresses(): string[] {
  if (typeof window === 'undefined') return []
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return []
    const parsed = JSON.parse(stored)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function markAlertDismissed(address: string): void {
  try {
    const dismissed = getAlertDismissedAddresses()
    if (!dismissed.includes(address.toLowerCase())) {
      dismissed.push(address.toLowerCase())
      localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissed))
    }
  } catch {
    // Silently fail if localStorage is unavailable (e.g., iOS Safari private browsing)
  }
}

export function wasAlertDismissed(address: string): boolean {
  return getAlertDismissedAddresses().includes(address.toLowerCase())
}
